/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {addSendSafelyRecipient} from '../api'

export const useMutationAddSendSafelyRecipient = createReactQueryMutationHook('addSendSafelyRecipient', addSendSafelyRecipient)
